/**
 * Normalize student emails before validation, uniqueness checks, and submit.
 * Matches onboarding-service / user-service: trim().toLowerCase().
 *
 * @param {unknown} email
 * @returns {string}
 */
const normalizeEmail = (email) => {
  if (email == null) return '';
  return String(email).trim().toLowerCase();
};

export default normalizeEmail;
